import React, { useEffect, useState } from "react";
import "../../Admin/admin.css";
import { endpoints } from "../../_config";
import { del, get, post, put } from "../../_services/apiService";
import { toast } from "react-toastify";
import AdminLayout from "../AdminLayout";

const emptyForm = {
    id: 0,
    problem_texts: "",
};

const formatDate = (value) => {
    if (!value) return "";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
};

const UserQuotationQuery = () => {
    const [problems, setProblems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editMode, setEditMode] = useState(false);
    const [formData, setFormData] = useState(emptyForm);

    const getProblems = async () => {
        setLoading(true);
        try {
            const response = await get(endpoints.GetQuotationUserProblem);
            const isSuccess = response?.isSuccess === 200 || response?.status === 200 || response?.success === true;

            if (isSuccess) {
                const list = Array.isArray(response?.data)
                    ? response.data
                    : Array.isArray(response?.data?.data)
                        ? response.data.data
                        : [];
                setProblems(list);
            } else {
                setProblems([]);
            }
        } catch (error) {
            setProblems([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getProblems();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const modelToggle = (modelname, status, item) => {
        if (status) {
            setEditMode(Boolean(item));
            setFormData(
                item
                    ? {
                          id: item.id,
                          problem_texts: item.problem_texts || "",
                      }
                    : emptyForm
            );
        }

        const modalElement = document.getElementById(modelname);
        let modal = window.bootstrap.Modal.getInstance(modalElement);
        if (!modal) {
            modal = new window.bootstrap.Modal(modalElement);
        }

        if (status) {
            modal.show();
        } else {
            modal.hide();
        }
    };

    const onReset = () => {
        setFormData(emptyForm);
        setEditMode(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.problem_texts.trim()) {
            toast.error("Problem text is required.");
            return;
        }

        try {
            const payload = {
                problem_texts: formData.problem_texts.trim(),
            };

            const response = editMode
                ? await put(`${endpoints.UpdateQuotationUserProblem}/${formData.id}`, payload)
                : await post(endpoints.SaveQuotationUserProblem, payload);

            if (response?.isSuccess === 200 || response?.isSuccess === 201 || response?.status === 200 || response?.status === 201 || response?.success === true) {
                toast.success(response?.message || (editMode ? "Problem updated successfully." : "Problem created successfully."));
                onReset();
                getProblems();
                modelToggle("modeldata", false);
            } else {
                toast.error(response?.message || "Failed to save problem.");
            }
        } catch (error) {
            toast.error("Please try again later.");
        }
    };

    const handleDelete = async (id) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this problem?");
        if (!isConfirmed) return;

        try {
            const response = await del(`${endpoints.DeleteQuotationUserProblem}/${id}`);
            if (response?.isSuccess === 200 || response?.status === 200 || response?.success === true) {
                toast.success(response?.message || "Problem deleted successfully.");
                getProblems();
            } else {
                toast.error(response?.message || "Failed to delete problem.");
            }
        } catch (error) {
            toast.error("Please try again later.");
        }
    };

    return (
        <AdminLayout>
            <div className="product_wepper">
                <div className="container-fluid">
                    <div className="row justify-content-end">
                        <div className="col-lg-7">
                            <div className="row align-items-center justify-content-end">
                                <div className="col-lg-5 col-md-6 col-sm-6 add_subcategory">
                                    <button type="button" className="all_sumbit_button" onClick={() => modelToggle("modeldata", true)}>
                                        + Add Problem
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mt-3 product_hedding_table_main" style={{ overflowX: "auto" }}>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Problem Text</th>
                                    <th>Entry Date</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="4" className="text-center">
                                            Loading...
                                        </td>
                                    </tr>
                                ) : problems.length > 0 ? (
                                    problems.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{index + 1}</td>
                                            <td>{item.problem_texts}</td>
                                            <td>{formatDate(item.created_at)}</td>
                                            <td>
                                                <div className="action_btn_weepr">
                                                    <span className="edit_icon_wepper" onClick={() => modelToggle("modeldata", true, item)} style={{ cursor: "pointer" }}>
                                                        <svg id="Layer_1" viewBox="0 0 512 512" width="15" height="15" xmlns="http://www.w3.org/2000/svg">
                                                            <g transform="matrix(1,0,0,1,0,0)">
                                                                <path
                                                                    d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z"
                                                                    fill="#000"
                                                                ></path>
                                                                <path
                                                                    d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z"
                                                                    fill="url(#gradient1)"
                                                                ></path>
                                                                <defs>
                                                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                                                        <stop offset="0%" stopColor="#000"></stop>
                                                                        <stop offset="100%" stopColor="#000"></stop>
                                                                    </linearGradient>
                                                                </defs>
                                                            </g>
                                                        </svg>
                                                    </span>
                                                    <span className="delete_icon_weepr ms-2" onClick={() => handleDelete(item.id)} style={{ cursor: "pointer" }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="15" height="15" viewBox="0 0 24 24">
                                                            <path
                                                                d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z"
                                                                fill="#FF0000"
                                                            ></path>
                                                        </svg>
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center">
                                            No records found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modeldata" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{editMode ? "Edit Problem" : "Add Problem"}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label" htmlFor="problem_texts">
                                        Problem Text
                                    </label>
                                    <textarea
                                        id="problem_texts"
                                        name="problem_texts"
                                        className="form-control"
                                        rows="4"
                                        placeholder="Enter quotation user problem"
                                        value={formData.problem_texts}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="all_sumbit_button">
                                    {editMode ? "Update" : "Save"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
};

export default UserQuotationQuery;
